/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import moment from 'moment';

export const always = (_value?: any) => true;

export const never = (_value?: any) => false;

export const isUndefined = (value: any): value is undefined => {
  return value === undefined;
};

export const isNull = (value: any): value is null => {
  return value === null;
};

export const isNil = (value: any): value is null | undefined => {
  return isUndefined(value) || isNull(value);
};

export const isMoment = (value: any) => {
  return moment.isMoment(value);
};

export const isDate = (value: any): value is Date => {
  return moment.isDate(value);
};

export const isDateLike = (value: any): value is moment.Moment | Date => {
  return isMoment(value) || isDate(value);
};
try {
    // @ts-ignore
    always.displayName = "always";
    // @ts-ignore
    always.__docgenInfo = { "description": "", "displayName": "always", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#always"] = { docgenInfo: always.__docgenInfo, name: "always", path: "src/services/predicate/common_predicates.ts#always" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    never.displayName = "never";
    // @ts-ignore
    never.__docgenInfo = { "description": "", "displayName": "never", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#never"] = { docgenInfo: never.__docgenInfo, name: "never", path: "src/services/predicate/common_predicates.ts#never" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isUndefined.displayName = "isUndefined";
    // @ts-ignore
    isUndefined.__docgenInfo = { "description": "", "displayName": "isUndefined", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#isUndefined"] = { docgenInfo: isUndefined.__docgenInfo, name: "isUndefined", path: "src/services/predicate/common_predicates.ts#isUndefined" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isNull.displayName = "isNull";
    // @ts-ignore
    isNull.__docgenInfo = { "description": "", "displayName": "isNull", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#isNull"] = { docgenInfo: isNull.__docgenInfo, name: "isNull", path: "src/services/predicate/common_predicates.ts#isNull" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isNil.displayName = "isNil";
    // @ts-ignore
    isNil.__docgenInfo = { "description": "", "displayName": "isNil", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#isNil"] = { docgenInfo: isNil.__docgenInfo, name: "isNil", path: "src/services/predicate/common_predicates.ts#isNil" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isMoment.displayName = "isMoment";
    // @ts-ignore
    isMoment.__docgenInfo = { "description": "", "displayName": "isMoment", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#isMoment"] = { docgenInfo: isMoment.__docgenInfo, name: "isMoment", path: "src/services/predicate/common_predicates.ts#isMoment" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isDate.displayName = "isDate";
    // @ts-ignore
    isDate.__docgenInfo = { "description": "", "displayName": "isDate", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#isDate"] = { docgenInfo: isDate.__docgenInfo, name: "isDate", path: "src/services/predicate/common_predicates.ts#isDate" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    isDateLike.displayName = "isDateLike";
    // @ts-ignore
    isDateLike.__docgenInfo = { "description": "", "displayName": "isDateLike", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/services/predicate/common_predicates.ts#isDateLike"] = { docgenInfo: isDateLike.__docgenInfo, name: "isDateLike", path: "src/services/predicate/common_predicates.ts#isDateLike" };
}
catch (__react_docgen_typescript_loader_error) { }